import React from 'react';

import { Button, ButtonSize, ButtonType, ButtonVariant } from 'components/Button';
import { arrowRight } from 'icons/default';

import styles from './Banner.module.scss';

interface Props {
  headline: string;
  content: string;
  link: string;
}

export const Banner: React.FC<Props> = ({ headline, content, link }) => (
  <div className={styles.full && styles.full}>
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <h3>{headline}</h3>
        <p>{content}</p>
        <div className={styles.inner}>
          <Button
            type={ButtonType.Button}
            trailingIcon={arrowRight}
            size={ButtonSize.Large}
            variant={ButtonVariant.Primary}
            href={link}
          >
            Läs mer
          </Button>
        </div>
      </div>
    </div>
  </div>
);
